<template>
    <svg
        width="27"
        height="24"
        viewBox="0 0 27 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M23.334 0H3.33398C2.53833 0 1.77527 0.316071 1.21266 0.87868C0.650055 1.44129 0.333984 2.20435 0.333984 3V17C0.333984 17.7956 0.650055 18.5587 1.21266 19.1213C1.77527 19.6839 2.53833 20 3.33398 20H12.334V22H9.33398C9.06877 22 8.81441 22.1054 8.62688 22.2929C8.43934 22.4804 8.33398 22.7348 8.33398 23C8.33398 23.2652 8.43934 23.5196 8.62688 23.7071C8.81441 23.8946 9.06877 24 9.33398 24H17.334C17.5992 24 17.8536 23.8946 18.0411 23.7071C18.2286 23.5196 18.334 23.2652 18.334 23C18.334 22.7348 18.2286 22.4804 18.0411 22.2929C17.8536 22.1054 17.5992 22 17.334 22H14.334V20H23.334C24.1296 20 24.8927 19.6839 25.4553 19.1213C26.0179 18.5587 26.334 17.7956 26.334 17V3C26.334 2.20435 26.0179 1.44129 25.4553 0.87868C24.8927 0.316071 24.1296 0 23.334 0ZM23.334 18H3.33398C3.06877 18 2.81441 17.8946 2.62688 17.7071C2.43934 17.5196 2.33398 17.2652 2.33398 17V15H24.334V17C24.334 17.2652 24.2286 17.5196 24.0411 17.7071C23.8536 17.8946 23.5992 18 23.334 18Z"
            fill="currentColor"
        />
    </svg>
</template>
